exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".invalidClientIdMessageError {\n  color: red;\n  font-size: 14px;\n}\n.disableRadioButtonText {\n  color: gray;\n  opacity: 0.5;\n}\n", ""]);

// exports
